import { Card, Form } from '@themesberg/react-bootstrap';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@themesberg/react-bootstrap';
import { useDispatch } from 'react-redux';
import { updateToastInfo } from '../../../actions/settings';
import { updateSpinnerState } from '../../../actions/spinner';
import {
  faCircleCheck,
  faCircleUser,
  faRefresh,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TableOnly from '../../scheme-management/Components/IndividualScheme/TableOnly';
import { currentLoadersColumns } from './columns';
import {
  getActiveLoaders,
  markLoaderInOrOut,
} from '../../../parse-functions/loaders';
import { useSelector } from 'react-redux';
import { returnWarehouseDropdownOptions } from '../../../utils/warehouse';
import EditableDropDown from '../../../components/common/EditableDropdown';
import LoaderDetailsModal from './LoaderDetailsModal';

const LoaderEntry = () => {
  const { t } = useTranslation();
  const [loaderCode, setLoaderCode] = useState('');
  const [selectedWarehouse, setSelectedWarehouse] = useState('');
  const [selectedLoader, setSelectedLoader] = useState(null);
  const [showLoaderDetailsModal, setShowLoaderDetailsModal] = useState(false);
  const [loaderData, setLoaderData] = useState({});
  const isAdmin = useSelector(
    (state) => state?.user?.preferences?.isAdmin || false
  );
  const otherWarehouses = useSelector(
    (state) => state?.user?.otherWarehousesInZone || {}
  );
  const storeName = useSelector(
    (state) => state?.user?.preferences?.storeName || ''
  );
  const dispatch = useDispatch();

  const fetchActiveLoaders = async () => {
    try {
      dispatch(updateSpinnerState(true));
      const data = await getActiveLoaders({
        warehouse: isAdmin ? '' : storeName,
      });
      setLoaderData(JSON.parse(JSON.stringify(data)));
    } catch (error) {
      dispatch(
        updateToastInfo({
          show: true,
          type: 'danger',
          title: t(`Error while fetching active loaders.`),
          message: error.message,
        })
      );
    } finally {
      dispatch(updateSpinnerState(false));
    }
  };
  console.log(loaderData);
  const loaderInAndOut = async (data, type) => {
    try {
      dispatch(updateSpinnerState(true));
      await markLoaderInOrOut({
        data,
        status: type,
      });
      setSelectedLoader(null);
      setShowLoaderDetailsModal(false);
      await fetchActiveLoaders();
    } catch (error) {
      dispatch(
        updateToastInfo({
          show: true,
          type: 'danger',
          title: t(`Error while marking ${type} loader.`),
          message: error.message,
        })
      );
    } finally {
      dispatch(updateSpinnerState(false));
    }
  };

  const handleLoaderFetch = async () => {
    try {
      const loader = await markLoaderInOrOut({
        data: {
          loaderCode,
          warehouse: isAdmin ? selectedWarehouse : storeName,
        },
        status: 'entry',
        getData: true,
      });
      setSelectedLoader(loader);
      setShowLoaderDetailsModal(true);
      // loaderInAndOut(
      //   { loaderCode, warehouse: isAdmin ? selectedWarehouse : storeName },
      //   'entry'
      // );
    } catch (err) {
      console.log(err);
      dispatch(
        updateToastInfo({
          show: true,
          type: 'danger',
          title: t(`Error while fetching loader details.`),
          message: err.message,
        })
      );
    }
  };

  const handleMarkIn = () => {
    loaderInAndOut(
      { loaderCode, warehouse: isAdmin ? selectedWarehouse : storeName },
      'entry'
    );
  };

  const handleMarkOut = (row) => {
    loaderInAndOut(
      {
        loaderCode: row.loader?.loaderCode,
        warehouse: isAdmin ? selectedWarehouse : storeName,
      },
      'exit'
    );
  };

  useEffect(() => {
    fetchActiveLoaders();
  }, []);
  return (
    <div>
      <h4 className="mt-2">{t('Loader Entry')}</h4>
      <Card className="mb-2">
        <Card.Body className="p-2 fw-bold">Mark Loader Entry</Card.Body>
      </Card>
      <Card className="mb-2">
        <Card.Body className="p-2 ">
          <div className="d-flex gap-5 align-items-center">
            <Form.Control
              type="text"
              id={'loaderCode'}
              value={loaderCode}
              onChange={(e) => {
                const value = e.target.value;
                setLoaderCode(value);
              }}
              style={{ backgroundColor: '#F0F0F0', width: 'auto' }}
              placeholder="Enter Loader Code"
            />
            {isAdmin && (
              <EditableDropDown
                width="300px"
                onChange={(option) => {
                  setSelectedWarehouse(option?.value);
                }}
                options={returnWarehouseDropdownOptions(otherWarehouses)}
                placeholder={t('Select Warehouse / Store Name')}
                backgroundColor="#F0F0F0"
                value={selectedWarehouse}
              />
            )}
            <Button
              onClick={() => handleLoaderFetch()}
              disabled={!loaderCode || (isAdmin && !selectedWarehouse)}
            >
              {t('Mark In')}
            </Button>
          </div>
        </Card.Body>
      </Card>
      <div className="d-flex gap-4 mb-2">
        <Card className="w-50">
          <Card.Body className="p-2 d-flex justify-content-between align-items-center">
            <div className="d-flex flex-column">
              <p className="mb-0">Total Loaders</p>
              <p className="mb-0">
                <span className="fw-bold">{loaderData?.totalLoaders || 0}</span>{' '}
                (as of Today)
              </p>
              <p className="mb-0">Registered In System</p>
            </div>
            <FontAwesomeIcon
              icon={faCircleUser}
              className="text-danger"
              size="2x"
            />
          </Card.Body>
        </Card>
        <Card className="w-50">
          <Card.Body className="p-2 d-flex justify-content-between align-items-center">
            <div className="d-flex flex-column">
              <p className="mb-0">Assigned</p>
              <p className="fw-bold mb-0">{loaderData?.assignedLoaders || 0}</p>
              <p className="mb-0">Currenty Working</p>
            </div>
            <FontAwesomeIcon
              icon={faCircleCheck}
              className="text-danger"
              size="2x"
            />
          </Card.Body>
        </Card>
      </div>
      <Card className="mb-2">
        <Card.Body className="p-2 d-flex justify-content-between align-items-center">
          <p className="mb-0 fw-bold">Current Loaders</p>
          <Button
            onClick={() => fetchActiveLoaders()}
            variant="outline-primary"
            className="d-flex align-items-center gap-2"
          >
            <FontAwesomeIcon icon={faRefresh} />
            Refresh
          </Button>
        </Card.Body>
      </Card>
      <TableOnly
        id={'loaderEntryTable'}
        columns={currentLoadersColumns(handleMarkOut)}
        data={loaderData?.currentLoaders || []}
      />
      <LoaderDetailsModal
        show={showLoaderDetailsModal}
        handleClose={() => setShowLoaderDetailsModal(false)}
        loader={selectedLoader}
        handleConfirm={handleMarkIn}
      />
    </div>
  );
};

export default LoaderEntry;
